
import UserMap from "@/domain/model/user/UserMap.js";
import RcDomainMap from "../../../common/RcDomainMap.js";
import CompanyMap from "../../company/CompanyMap.js";
import EmployeePreferences from "./EmployeePreferences.js";

export default class EmployeePreferencesMap extends RcDomainMap {
  static MODEL_NAME = "EmployeePreferencesMap";
  
  constructor(domain, data) {
    super(domain, data, EmployeePreferencesMap.MODEL_NAME);
  }

  first() {
    var values = Object.values(this.data);
    return new EmployeePreferences(this.domain, values[0]);
  }
  
  copy() {
    var data = this._copy();
    return new EmployeePreferencesMap(this.domain, data);
  }
  
  companys() {
    var values = new CompanyMap(this.domain);
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var item = this.getEmployeePreferences(key);
      values.add(item.company());
    }
    return values;
  }

  users() {
    var values = new UserMap(this.domain);
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var item = this.getEmployeePreferences(key);
      values.add(item.user());
    }
    return values;
  }

  active() {
    var values = new EmployeePreferencesMap(this.domain);
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var item = this.getEmployeePreferences(key);
      if (item.isStateActive()) {
        values.add(item);
      }
    }
    return values;
  }

  forUser(user) {
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var item = this.getEmployeePreferences(key);
      if (item.user().id() === user.id()) {
        return item;
      }
    }
    return new EmployeePreferences(this.domain);
  }
  
  findByCompanyId(companyId) {
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var item = this.getEmployeePreferences(key);
      if (item.company().id() === companyId) {
        return item;
      }
    }
    return new EmployeePreferences(this.domain);
  }
  
  list() {
    var values = [];
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var item = this.getEmployeePreferences(key);
      values.push(item);
    }
    return values;
  }
  
  getEmployeePreferences(key) {
    var value = super.get(key);
    return new EmployeePreferences(this.domain, value);
  }
 
  pointers() {
    var map = new EmployeePreferencesMap(this.domain);
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var item = new EmployeePreferences(this.domain, {'@rid': key});
      map.add(item);
    }
    return map;
  }
}